var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","id":_vm.id,"data-action":"iconPicker","name":"icon_class"},domProps:{"value":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }